import React from "react";

import {
  MButton2,
  MCheckbox,
  MInput,
  MLabel,
  MSearchUniversity,
  ValidatedForm,
} from "components/forms";
import { payloadBuilder } from "libs";
import dayjs from "dayjs";
import { MnemoCallout } from "components/misc";

export class FormTitleStep1 extends ValidatedForm {
  constructor(props) {
    super(props);

    // bind event handler to invoke it from child component
    this.onChange = this.onChange.bind(this);
  }

  emptyFields = {
    istitution: "",
    aa: "",
    dataConseguimento: "",
    baseVote: 110,
    votoTitolo: "",
    lode: false,
    city: "",
    nation: "",
    contactName: "",
    contactPhone: "",
    contactFax: "",
    contactEmail: "",
    contactPec: "",
  };

  state = {
    showSearchUniversity: false,
    university: {},
    ...this.emptyFields,
    defaultValues: {
      ...this.emptyFields,
    },
  };

  ERROR_MESSAGES = {
    istitution: "Dato obbligatorio",
    dataConseguimento: "Dato non valido",
    aa: "Inserire l'anno accademico in formato AAAA/AAAA",
    baseVote: "Dato obbligatorio e numerico",
    votoTitolo: "Dato obbligatorio e numerico (min. 60, max. 110)",
    city: "Dato obbligatorio",
  };

  validation = {
    istitution: (value) => value !== "",
    city: (value) => value !== "",
    dataConseguimento: (value) => this.validateDataConseguimento(value),
    aa: (value) => this.validateAA(value),
    votoTitolo: (value) => this.validateVoteBaseVote(value),
    baseVote: (value) => this.validateVoteBaseVote(value),
    //lode: () => this.onChangeLode(),
  };

  FormTitleStep1Configurator = [
    [
      {
        field: "searchUniversity",
        component: MButton2,
        onClick: (e) => {
          this.searchUniversity(e);
        },
        label: "Cerca Ateneo",
        className: "col-md-12 mb-5 ",
        classElement: "btn btn-primary bg-dark",
      },
    ],
    [
      {
        field: "city",
        label: "Città Università",
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
      {
        field: "istitution",
        label: "Università",
        component: MInput,
        type: "text",
        className: "col-md-6",
        readOnly: true,
      },
    ],
    [
      {
        field: "votoTitolo",
        label: "Voto",
        component: MInput,
        type: "text",
        className: "col-md-4",
      },
      {
        field: "baseVote",
        label: "Base Voto",
        component: MInput,
        type: "text",
        className: "col-md-4",
        readOnly: true,
      },
      {
        id: "lode",
        name: "lode",
        field: "lode",
        label: "Lode",
        component: MCheckbox,
        className: "col-md-4",
        infoText:
          "puoi selezionare la lode quando Voto e Base Voto sono uguali",
        onChange: () => this.onChangeLode(),
      },
    ],
    [
      {
        field: "aa",
        label: "Anno Accademico conseguimento Titolo",
        component: MInput,
        infoText: "inserire formato AAAA/AAAA",
        className: "col-md-6 p-3",
      },
      {
        field: "dataConseguimento",
        label: "Data conseguimento titolo",
        component: MInput,
        type: "date",
        className: "col-md-6 p-3",
      },
    ],
    [
      {
        field: "preferExamPresence",
        label: "Informazioni facoltative:",
        infoText:
          "Informazioni per la verifica dei dati ex articolo 15, comma 1, punto e della legge 183/2011. Recapiti della segreteria competente.",
        component: MLabel,
        className: "col-md-12",
      },
    ],
    [
      {
        field: "contactName",
        label: "Denominazione",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
    ],
    [
      {
        field: "contactPhone",
        label: "Telefono",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
      {
        field: "contactFax",
        label: "Fax",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
    ],
    [
      {
        field: "contactEmail",
        label: "Email",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
      {
        field: "contactPec",
        label: "Pec",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
    ],
  ];

  normalize = (v) => {
    if (!v) return "";
    if (typeof v === "object" && v.value !== undefined) return v.value;
    return v;
  };

  //--- ---

  validateVoteBaseVote = (value) => {
    this.onChangeLode();

    if (value === "") {
      return false;
    }

    if (isNaN(value)) {
      return false;
    }

    if (value < 60 || value > 110) {
      return false;
    }

    return true;
  };

  validateAA = (value) => {
    //--- reset dataConseguimento ---
    this.setState({ dataConseguimento: "" });

    value = value.trim();
    let formAA = /^(\d{4})\/(\d{4})$/.test(value);

    if (!formAA) {
      return false;
    } else {
      formAA = value.split("/");
      var dbAA = [];

      const currentYear = new Date().getFullYear();
      if (parseInt(formAA[1]) > currentYear) {
        return false;
      }

      if (parseInt(formAA[0]) + 1 === parseInt(formAA[1])) {
        //--- ---
        if (
          this.props.item.aaStart !== null &&
          this.props.item.achievementDateEnd === null
        ) {
          //nell'anno aa
          dbAA = this.props.item.aaStart.split("/");
          if (parseInt(formAA[1]) < parseInt(dbAA[1])) {
            return false;
          }

          return true;
        }

        //--- ---
        if (
          this.props.item.aaStart !== null &&
          this.props.item.achievementDateEnd !== null
        ) {
          dbAA = this.props.item.aaStart.split("/");
          const DbdateY = dayjs(this.props.item.achievementDateEnd).format(
            "YYYY"
          );

          if (
            parseInt(formAA[1]) > parseInt(DbdateY) ||
            parseInt(formAA[1]) < parseInt(dbAA[1])
          ) {
            return false;
          }

          return true;
        }

        //--- ---
        if (this.props.item.aaEnd !== null) {
          //entro l'anno aa
          dbAA = this.props.item.aaEnd.split("/");
          if (parseInt(formAA[1]) > parseInt(dbAA[1])) {
            return false;
          }

          return true;
        }

        return true;
      } else {
        return false;
      }
    }
  }; //validateAA

  validateDataConseguimento = (value) => {
    let regex = /^\d{4}-\d{2}-\d{2}$/;
    if (value === "" || !value.match(regex)) {
      return false;
    }

    //--- ---
    const today = new Date();
    const formDate = new Date(value);

    //in the future not valid
    if (formDate > today) {
      return false;
    }

    //--- ---
    if (Number.isNaN(formDate.getTime())) {
      return false;
    }
    const [year, month, day] = value.split("-").map(Number);

    if (month > 12 || day > 31) {
      return false;
    }

    const currentYear = new Date().getFullYear();
    if (year < currentYear - 90 || year > currentYear) {
      return false;
    }

    const aa = this.normalize(this.state.aa);

    //--- guard on compliant AA --
    if (aa) {
      const aaSplit = aa.split("/");
      const firstDate = new Date(`${parseInt(aaSplit[1])}-03-01`);
      const secondDate = new Date(`${parseInt(aaSplit[1]) + 1}-04-30`);

      if (formDate < firstDate || formDate > secondDate) {
        return false;
      }
    }

    /* CALOGERO: perchè questo controllo?
    if (this.props.item.aaStart !== null) {
      let aa = this.props.item.aaStart.split("/");
      const firstDate = new Date(`${parseInt(aa[1])}-03-01`);
      const secondDate = new Date(`${parseInt(aa[1]) + 1}-04-30`);

      if (formDate < firstDate || formDate > secondDate) {
        return false;
      }
    }
*/

    //--- ---
    if (this.props.item.achievementDateStart !== null) {
      const formDate = new Date(value);
      const Dbdate = new Date(
        dayjs(this.props.item.achievementDateStart).format("YYYY-MM-DD")
      );

      if (formDate < Dbdate) {
        return false;
      }

      return true;
    }

    //--- ---
    if (this.props.item.achievementDateEnd !== null) {
      const formDate = new Date(value);
      const Dbdate = new Date(
        dayjs(this.props.item.achievementDateEnd).format("YYYY-MM-DD")
      );

      if (formDate > Dbdate) {
        return false;
      }

      return true;
    }

    /*if (this.props.item.aaEnd !== null) {
      //entro l'anno aa
      const dbAA = this.props.item.aaEnd.split("/");
      const formAA = value.split("/");
      if (parseInt(formAA[1]) > parseInt(dbAA[1])) {
        return false;
      }
    }*/

    if (
      this.props.item.achievementDateStart === null &&
      this.props.item.achievementDateEnd === null
    ) {
      return true;
    }
  };

  onChangeLode = () => {
    const votoTitolo = this.normalize(this.state.votoTitolo);
    const baseVote = this.normalize(this.state.baseVote);

    if (
      isNaN(votoTitolo) ||
      isNaN(baseVote) ||
      votoTitolo === "" ||
      baseVote === "" ||
      parseInt(votoTitolo) !== parseInt(baseVote)
    ) {
      this.setState({ lode: { value: false, isValid: true } });
      return false;
    }

    return true;
  };

  componentDidMount() {
    const { defaultPayload } = this.props;

    if (defaultPayload) {
      const university = {
        city: defaultPayload.city,
        istitution: defaultPayload.istitution,
        uniCode: defaultPayload.uniCode,
      };

      this.setState({
        defaultValues: defaultPayload,
        ...defaultPayload,
        showSearchUniversity: false,
        university,
      });

      this.onChangeUniversity(university);
    }
  }

  getFormLabel = () => {
    return this.props.qualificationType;
  };

  getPayload = () => {
    this.payload = payloadBuilder(this.state);
    this.payload.qualificationType = this.props.qualificationType;
    this.payload.description = this.props.qualificationType;
    this.payload.qualificationCode = "title11";
    this.payload.template = this.props.extCode;
    this.payload.extCode = this.props.extCode;
    this.payload.qteId = this.props.item.value;

    if (!this.payload.nation) {
      this.payload.nation = "Italia";
    }

    this.payload.uniCode = this.state.university.uniCode;

    return this.payload;
  };

  searchUniversity = () => {
    this.setState({ showSearchUniversity: !this.state.showSearchUniversity });
  };

  onChangeUniversity = (university) => {
    this.onChange("city", university.city);
    this.onChange("istitution", university.istitution);
    this.setState({
      showSearchUniversity: false,
      university: university,
    });
  };

  //--- ---

  render() {
    const { defaultValues, showSearchUniversity } = this.state;

    const fields = this.FormTitleStep1Configurator;
    const { code } = this.renderFields(fields, defaultValues, true);
    const { note } = this.props.item;

    return (
      <>
        {note && note.length > 0 && <MnemoCallout>{note}</MnemoCallout>}
        {showSearchUniversity && (
          <>
            <MSearchUniversity
              onChange={this.onChangeUniversity}
              searchUniversity={this.searchUniversity}
              isForeign={false}
            />
          </>
        )}

        {!showSearchUniversity && <form className="user mt-5">{code}</form>}
      </>
    );
  }
}
